import { render } from "./Selection.vue?vue&type=template&id=3b866d14"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"
script.render = render

export default script